module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAQCAYAAAArij59AAAAGElEQVQokWPkmPz/PwMewIRPclTBcFMAAHbEArnZ6+XIAAAAAElFTkSuQmCC"